var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"custom-header"},[_c('div',{staticClass:"header-text",on:{"click":_vm.changeId}},[_vm._v("Mapa socioeconómico de El Salvador")]),_c('img',{staticClass:"header-image",attrs:{"src":"https://www.undp.org/sites/g/files/zskgke326/files/2024-10/undp_sv_pnud_logo.png","alt":"Header Image"},on:{"click":_vm.changeId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }